import { BaseCustomTableStyled, ScrollStyles } from './style'
import { BaseTableProps } from '../BaseTable'
import { Flex } from '@mantine/core'
import useLangPrefix from '@/hooks/useLangPrefix'

const BaseCustomTable = <T, P>({
  tfoot,
  data,
  columns,
  loadingSection,
  loading,
  emptySection,
  itemOnClick,
  // styles,
}: BaseTableProps<T, P>) => {
  const { isAr } = useLangPrefix()
  return (
    <ScrollStyles>
      <BaseCustomTableStyled
        dir=""
        border={0}
        horizontalSpacing={12}
        verticalSpacing={0}
        highlightOnHover={false}
        withColumnBorders={false}
      >
        <thead className="gui-table-thead">
          <tr className="gui-table-thead-tr">
            {columns.map((item, index) => (
              <th
                className="gui-table-th"
                key={'thead' + index}
                style={
                  item?.fixed
                    ? isAr
                      ? {
                          position: 'sticky',
                          right: 0,
                        }
                      : {
                          position: 'sticky',
                          left: 0,
                        }
                    : {}
                }
              >
                {item?.extraTitle ? (
                  <Flex gap={4}>
                    {item?.extraTitle}
                    {item?.renderTitle?.(item.title as string) ?? item.title}
                  </Flex>
                ) : (
                  <>{item?.renderTitle?.(item.title as string) ?? item.title}</>
                )}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="gui-table-tbody">
          {loading && loadingSection}
          {data?.list?.length ? (
            <>
              {data?.list?.map((row, index) => (
                <tr onClick={() => void itemOnClick?.(row as any)} className="gui-table-tbody-tr" key={'row' + index}>
                  {columns?.map((item, itemIndex) => (
                    <>
                      {item?.colSpan?.(row) === 0 ? null : (
                        <td
                          style={
                            item?.fixed
                              ? isAr
                                ? {
                                    position: 'sticky',
                                    right: 0,
                                    zIndex: 1,
                                  }
                                : {
                                    position: 'sticky',
                                    left: 0,
                                    zIndex: 1,
                                  }
                              : {}
                          }
                          className="gui-table-td"
                          colSpan={item?.colSpan?.(row)}
                          key={'td' + itemIndex}
                        >
                          {item?.render?.(row) ?? ''}
                        </td>
                      )}
                    </>
                  ))}
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan={columns.length}>
                <Flex className="gui-table-empty" w={'100%'} py={40} justify="center">
                  {emptySection}
                </Flex>
              </td>
            </tr>
          )}
        </tbody>

        {tfoot && (
          <tfoot className="gui-table-tfoot">
            <tr>{tfoot}</tr>
          </tfoot>
        )}
      </BaseCustomTableStyled>
    </ScrollStyles>
  )
}

export default BaseCustomTable
